import moment from 'moment-timezone'
import * as R from 'ramda'
import { timeFormat } from 'commons/date'

//MARK:- This function is copy from
//MARK:- https://stackoverflow.com/questions/29303164/get-all-months-name-from-year-in-moment-js
const getMonthNames = (languageCode, frmt) => {
  //MARK:- To prevent from accidently chaning locale and affect another function.
  let systemMoment = moment.locale()
  moment.locale(languageCode)
  var m = moment()
  var months = [...Array(12).keys()].map((_, index) => {
    return m.month(index).format(frmt)
  })
  //MARK:- When finish process set it back to prevent bug
  moment.locale(systemMoment)
  //MARK:- Return the array of months
  return months
}

const getNumberOfUnitAndUnitInName = ({
  numberOfUnit,
  singularUnitInLocalization,
  pluralUnitInLocalization,
}) => {
  return {
    numberOfUnit,
    unitInName:
      numberOfUnit === 1
        ? singularUnitInLocalization
        : pluralUnitInLocalization,
  }
}

export const getDateTimeDiff = (nowMoment, timestampMoment) => {
  return {
    diffTimeInYears: nowMoment.diff(timestampMoment, 'years'),
    diffTimeInMonths: nowMoment.diff(timestampMoment, 'months'),
    diffTimeInWeeks: nowMoment.diff(timestampMoment, 'weeks'),
    diffTimeInDays: nowMoment.diff(timestampMoment, 'days'),
    diffTimeInHours: nowMoment.diff(timestampMoment, 'hours'),
    diffTimeInMinutes: nowMoment.diff(timestampMoment, 'minutes'),
    diffTimeInSeconds: nowMoment.diff(timestampMoment, 'seconds'),
    diffTimeInMilliseconds: nowMoment.diff(timestampMoment),
  }
}

const getLocalizedUnitAgo = ({
  languageCode,
  timezoneFullNameIdentifier,
  nowMoment,
  timestampMoment,
  formatMessage,
}) => {
  //MARK:- The supported measurements are years, months, weeks, days, hours, minutes, and seconds.
  const {
    diffTimeInYears,
    diffTimeInMonths,
    diffTimeInWeeks,
    diffTimeInDays,
    diffTimeInHours,
    diffTimeInMinutes,
    diffTimeInSeconds,
    diffTimeInMilliseconds,
  } = getDateTimeDiff(nowMoment, timestampMoment)
  let monthNames = getMonthNames(languageCode, 'MMMM')
  let fullMonth = monthNames[timestampMoment.month()]
  let fullYear = timestampMoment.year()
  let dayInMonth = timestampMoment.date()
  let timeInHourMinute = timestampMoment
    .tz(timezoneFullNameIdentifier)
    .format(timeFormat)

  const offsets = moment.tz(timezoneFullNameIdentifier).format('Z')

  if (diffTimeInYears > 0) {
    let numberOfUnitAndUnitInName = getNumberOfUnitAndUnitInName({
      numberOfUnit: diffTimeInYears,
      singularUnitInLocalization: formatMessage({
        id: 'humanizedTimeIndicator.year',
      }),
      pluralUnitInLocalization: formatMessage({
        id: 'humanizedTimeIndicator.years',
      }),
    })
    return formatMessage(
      { id: 'humanizedTimeIndicator.fullUnitTimeInYearMonthWeekDisplayAgo' },
      {
        fullYear: fullYear,
        fullMonth: fullMonth,
        dayInMonth: dayInMonth,
        timeInHourMinute,
        offsets,
        ...numberOfUnitAndUnitInName,
      },
    )
  } else if (diffTimeInMonths > 0) {
    let numberOfUnitAndUnitInName = getNumberOfUnitAndUnitInName({
      numberOfUnit: diffTimeInMonths,
      singularUnitInLocalization: formatMessage({
        id: 'humanizedTimeIndicator.month',
      }),
      pluralUnitInLocalization: formatMessage({
        id: 'humanizedTimeIndicator.months',
      }),
    })
    return formatMessage(
      { id: 'humanizedTimeIndicator.fullUnitTimeInYearMonthWeekDisplayAgo' },
      {
        fullYear: fullYear,
        fullMonth: fullMonth,
        dayInMonth: dayInMonth,
        timeInHourMinute,
        offsets,
        ...numberOfUnitAndUnitInName,
      },
    )
  } else if (diffTimeInWeeks > 0) {
    let numberOfUnitAndUnitInName = getNumberOfUnitAndUnitInName({
      numberOfUnit: diffTimeInWeeks,
      singularUnitInLocalization: formatMessage({
        id: 'humanizedTimeIndicator.week',
      }),
      pluralUnitInLocalization: formatMessage({
        id: 'humanizedTimeIndicator.weeks',
      }),
    })
    return formatMessage(
      { id: 'humanizedTimeIndicator.fullUnitTimeInYearMonthWeekDisplayAgo' },
      {
        fullYear: fullYear,
        fullMonth: fullMonth,
        dayInMonth: dayInMonth,
        timeInHourMinute,
        offsets,
        ...numberOfUnitAndUnitInName,
      },
    )
  } else if (diffTimeInDays > 1) {
    return formatMessage(
      { id: 'humanizedTimeIndicator.fullUnitTimeInDaysDisplayAgo' },
      {
        fullYear: fullYear,
        fullMonth: fullMonth,
        dayInMonth: dayInMonth,
        timeInHourMinute,
        offsets,
        numberOfUnit: diffTimeInDays,
      },
    )
  } else if (diffTimeInDays === 1) {
    //MARK:- Yesyerday
    return formatMessage(
      { id: 'humanizedTimeIndicator.fullUnitTimeInYesterdayDisplayAgo' },
      {
        fullYear: fullYear,
        fullMonth: fullMonth,
        dayInMonth: dayInMonth,
        timeInHourMinute,
        offsets,
      },
    )
  } else if (diffTimeInHours > 0) {
    let numberOfUnitAndUnitInName = getNumberOfUnitAndUnitInName({
      numberOfUnit: diffTimeInHours,
      singularUnitInLocalization: formatMessage({
        id: 'humanizedTimeIndicator.hour',
      }),
      pluralUnitInLocalization: formatMessage({
        id: 'humanizedTimeIndicator.hours',
      }),
    })
    return formatMessage(
      { id: 'humanizedTimeIndicator.fullUnitTimeInHoursMinutesDisplayAgo' },
      {
        ...numberOfUnitAndUnitInName,
      },
    )
  } else if (diffTimeInMinutes > 0) {
    let numberOfUnitAndUnitInName = getNumberOfUnitAndUnitInName({
      numberOfUnit: diffTimeInMinutes,
      singularUnitInLocalization: formatMessage({
        id: 'humanizedTimeIndicator.min',
      }),
      pluralUnitInLocalization: formatMessage({
        id: 'humanizedTimeIndicator.mins',
      }),
    })
    return formatMessage(
      { id: 'humanizedTimeIndicator.fullUnitTimeInHoursMinutesDisplayAgo' },
      {
        ...numberOfUnitAndUnitInName,
      },
    )
  } else if (diffTimeInSeconds > 0 || diffTimeInMilliseconds >= 0) {
    return formatMessage({ id: 'humanizedTimeIndicator.justNow' })
  } else {
    return `unhandler case:${timestampMoment}`
  }
}

export const humanizedTimeIndicator = ({
  timestamp,
  languageCode,
  formatMessage,
  nowStampTime,
  timezone,
}) => {
  let nowMoment = nowStampTime === null ? moment() : moment(nowStampTime)
  let timestampMoment = timezone
    ? moment(timestamp).tz(timezone)
    : moment(timestamp)
  //MARK:- From any zone will be convert to local machine timezone
  const result = getLocalizedUnitAgo({
    languageCode,
    timezoneFullNameIdentifier: R.isNil(timezone)
      ? moment.tz.guess()
      : timezone,
    nowMoment,
    timestampMoment,
    formatMessage,
  })
  return result
}
